module.exports = __webpack_public_path__ + "9d2c0ad2f697c0e081a33a460bff7ccc.jpg";